__turbopack_context__.v({
  "blocksBackgroundColor": "WebAppInstallPrompt-module-scss-module__OoZnUq__blocksBackgroundColor",
  "blocksFontColor": "WebAppInstallPrompt-module-scss-module__OoZnUq__blocksFontColor",
  "container": "WebAppInstallPrompt-module-scss-module__OoZnUq__container",
  "containerIosSafariPosition": "WebAppInstallPrompt-module-scss-module__OoZnUq__containerIosSafariPosition",
  "containerPush": "WebAppInstallPrompt-module-scss-module__OoZnUq__containerPush",
  "icon": "WebAppInstallPrompt-module-scss-module__OoZnUq__icon",
  "installButton": "WebAppInstallPrompt-module-scss-module__OoZnUq__installButton",
  "secondaryNavBackgroundColor": "WebAppInstallPrompt-module-scss-module__OoZnUq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "WebAppInstallPrompt-module-scss-module__OoZnUq__themeBackgroundColor",
  "themeFontColor": "WebAppInstallPrompt-module-scss-module__OoZnUq__themeFontColor",
});
